import ItemPicture from "./ItemPicture";

import { IFileData } from "@rf-l1/file/helpers/create-file-data";

import { CPropertyFormKeys } from "../../../../util/schemas/property-schema/propertySchema";
import MxFormL3FileCarruselField from "@rf-l3/form/MxFormL3CarruselField";
import useManagerImagesDraft from "../../../../hooks/useManagerImagesDraft";
import useManagerImagesEdit from "../../../../hooks/useManagerImagesEdit";
import { useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import { HCatchServerError } from "@/src-refactor/modules/shared/components/refactor/helpers/cath-error-server";

const CarruselImagesFormSection = () => {
  const { uploadImageDraft, deleteImageDraft, deleteAllImagesDraft } = useManagerImagesDraft();
  const { uploadImageEdit, deleteImageEdit, deleteAllImagesEdit } = useManagerImagesEdit();
  const { pathname } = useLocation();
  const isEdit = /^\/realestates\/(project\/)?editar\/\d+$/.test(pathname);

  return (
    <MxFormL3FileCarruselField
      withreacthookform={1}
      label="Fotos de la propiedad"
      name={CPropertyFormKeys.images_property}
      accept={[".png", ".jpg", ".jpeg"]}
      maxSize={10}
      minSize={0}
      height="260px"
      uploadMethod={(isEdit ? uploadImageEdit : uploadImageDraft) as any}
      onAfterDeleteAllFiles={(current, api) =>
        (isEdit
          ? deleteAllImagesEdit(current as any)
          : deleteAllImagesDraft(current as any)
        )
          .then(res => {
            api.set(res?.remaining ?? []);
            if (res?.failedDeletions?.length) {
              const firstError = res.failedDeletions[0]?.error;
              toast.error(HCatchServerError(firstError));
            }
          })
          .catch(err => {
            toast.error(HCatchServerError(err));
          })
      }
      direction="horizontal"
      itemRender={(item: IFileData, index: number) => {
        return (
          <ItemPicture
            {...item}
            index={index}
            key={item.id}
            deleteFile={() => (isEdit ? deleteImageEdit(index) : deleteImageDraft(index))}
          />
        );
      }}
    />
  );
};

export default CarruselImagesFormSection;
